import { Grid, makeStyles, Tooltip, useMediaQuery } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import * as PropTypes from 'prop-types'
import React from 'react'
import { darkBlue, defaultC } from 'asterX-UI/constants/colors'

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.grey[400],
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400
  },
  value: {
    color: theme.palette.grey[700],
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400
  },
  labelMob: {
    color: theme.palette.grey[400],
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400
  },
  valueMob: {
    color: theme.palette.grey[700],
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400
  },

  secondValue: {
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(15),
    color: darkBlue
  }
}))

const FieldInfo = ({
  label,
  value,
  secondVal,
  classNameValue,
  classNameSValue,
  classNameLabel,
  vertical = false,
  styleLabel,
  styleValue,
  styleSValue,
  tooltipValue = false,
  onClick,
  md = 12,
  xs = 12,
  lg,
  xl,
  justifyContent,
  color
}) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'))

  return (
    <Grid
      item
      container
      xs={xs}
      md={md}
      sm={xs}
      lg={lg}
      onClick={onClick ? onClick : null}
      xl={!!xl ? xl : md}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      spacing={1}
      direction={vertical ? 'column' : 'row'}
      justifyContent={justifyContent}
    >
      <Grid item>
        <Typography
          style={styleLabel}
          className={
            classNameLabel
              ? classNameLabel
              : isMobile
              ? classes.labelMob
              : classes.label
          }
        >
          {label}
        </Typography>
      </Grid>

      <Grid item>
        {tooltipValue ? (
          <Tooltip title={value} placement={'bottom-start'}>
            <Typography
              style={styleValue}
              className={
                classNameValue
                  ? classNameValue
                  : isMobile
                  ? classes.valueMob
                  : classes.value
              }
            >
              {value}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            style={styleValue}
            className={
              classNameValue
                ? classNameValue
                : isMobile
                ? classes.valueMob
                : classes.value
            }
          >
            {value}
          </Typography>
        )}
      </Grid>
      {secondVal && (
        <Grid item>
          <Typography
            style={styleSValue}
            className={classNameSValue ? classNameSValue : classes.secondValue}
          >
            {secondVal}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}
export default FieldInfo
FieldInfo.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variantLabel: PropTypes.string,
  classNameValue: PropTypes.string
}
